<script>
export default {
  name: 'home',
  data() {
    return {
      activeIndex: this.$route.path,
      timer: null,
      // 响应式布局
      adaptation: {
        nav: 'app-nav-lg',
        main: 'app-main-lg',
        class: ''
      },
      screenWidth: document.body.clientWidth,
      visible: null,
      isCollapse: false
    };
  },
  created() {
    const that = this
    // 核心方法，主要 根据窗口的变化 来控制布局
    window.onresize = () => {
      window.screenWidth = document.body.clientWidth
      // 第二步
      that.screenWidth = window.screenWidth
      window.screenWidth >= 1200 ? that.isCollapse = false : that.isCollapse = true
      that.changeWidth(window.screenWidth)
    }
    window.onresize()
    window.addEventListener(
      "click",
      () => {
        sessionStorage.setItem("lastClickTime", new Date().getTime());
      },
      true
    );
  },
  mounted() {
    this.isTimeOut();
  },
  methods: {
    changeWidth(clientWidth) {
      this.visible = true
      // 主要根据 窗口变化 到一定位置时，变换样式
      if (clientWidth >= 1200) {
        // el-menu-vertical-demo el-menu-demo
        this.adaptation.nav = 'app-nav-lg'
        this.adaptation.main = 'app-main-lg'
      } else if (clientWidth >= 992) {
        this.adaptation.nav = 'app-nav-md'
        this.adaptation.main = 'app-main-md'
      } else if (clientWidth >= 768) {
        this.adaptation.nav = 'app-nav-sm'
        this.adaptation.main = 'app-main-sm'
      } else if (clientWidth < 768) {
        this.adaptation.nav = 'hidden-xs-only app-nav-xs'
        this.adaptation.main = 'app-main-xs'
        this.visible = false
      } else this.$message.warning({message: '未知像素错误'})
      console.log('当前窗口大小', clientWidth)
    },
    isTimeOut() {
      // 使用定时器之前，要清除一下定时器
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        let lastClickTime = sessionStorage.getItem("lastClickTime") * 1; // 把上次点击时候的字符串时间转换成数字时间
        let nowTime = new Date().getTime(); // 获取当前时间
        // 假设我们需求是：5秒钟不进行点击操作，就提示登录退出
        if (nowTime - lastClickTime > 1000 * 60 * 60) {
          // 提示一下用户
          this.$alert('长时间未操作，请重新登录', '重新登录', {
            confirmButtonText: '确定',
            type: "error"
          });
          // 这里要清除定时器，结束任务
          clearInterval(this.timer);
          // 最后返回到登录页
          this.$router.push({path: "/login"});
        }
      }, 1000 * 60);
    },
  },
  beforeDestroy() {
    // 最后一步，离开页面的时候，清除一下定时器，也解绑点击事件
    clearInterval(this.timer);
    window.removeEventListener("click", () => {
    }, true);
  },
}
</script>
<template>
  <el-container>
    <el-aside width="100" :class="adaptation.nav">
      <el-menu
        router
        :collapse="isCollapse"
        :default-active="$route.path"
        class="el-menu-vertical-demo">
        <el-menu-item index="/index">
          <template slot="title">
            <i class="el-icon-s-home"></i>
            <span>首页</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/user">
          <i class="el-icon-user"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
        <el-menu-item index="/productAuthorization">
          <i class="el-icon-s-grid"></i>
          <span slot="title">商品授权</span>
        </el-menu-item>
        <el-menu-item index="/classImg">
          <i class="el-icon-picture"></i>
          <span slot="title">分类图片管理</span>
        </el-menu-item>
        <el-menu-item index="/stockImg">
          <i class="el-icon-picture-outline"></i>
          <span slot="title">商品图片管理</span>
        </el-menu-item>
        <el-menu-item index="/memo">
          <i class="el-icon-notebook-2"></i>
          <span slot="title">备忘录管理</span>
        </el-menu-item>
        <el-menu-item index="/indexClass">
          <i class="el-icon-menu"></i>
          <span slot="title">首页分类管理</span>
        </el-menu-item>
        <el-menu-item index="/promotional">
          <i class="el-icon-s-goods"></i>
          <span slot="title">促销商品管理</span>
        </el-menu-item>
        <el-menu-item index="/newproducts">
          <i class="el-icon-shopping-bag-2"></i>
          <span slot="title">新品推荐管理</span>
        </el-menu-item>
        <el-menu-item index="/admin">
          <i class="el-icon-s-custom"></i>
          <span slot="title">管理员管理</span>
        </el-menu-item>
        <el-menu-item index="/log">
          <i class="el-icon-s-grid"></i>
          <span slot="title">登录记录</span>
        </el-menu-item>

<!--        <el-menu-item index="/productViewTotal">-->
<!--          <i class="el-icon-s-order"></i>-->
<!--          <span slot="title">商品查看统计</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item index="/userProductDetail">-->
<!--          <i class="el-icon-s-data"></i>-->
<!--          <span slot="title">用户查看统计</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item index="/dau">-->
<!--          <i class="el-icon-s-marketing"></i>-->
<!--          <span slot="title">日活</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item index="/UserConsumeRank">-->
<!--          <i class="el-icon-s-marketing"></i>-->
<!--          <span slot="title">消费统计</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item index="/DailyOrderStat">-->
<!--          <i class="el-icon-s-marketing"></i>-->
<!--          <span slot="title">订单统计</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item index="/OrderLogDetail">-->
<!--          <i class="el-icon-s-marketing"></i>-->
<!--          <span slot="title">订单记录</span>-->
<!--        </el-menu-item>-->
      </el-menu>
    </el-aside>
    <el-container :class="adaptation.main">
      <router-view></router-view>
    </el-container>
  </el-container>
</template>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  min-height: 400px;
  height: calc(95vh);
}

.app-main-lg::-webkit-scrollbar, .app-main-md::-webkit-scrollbar,
.app-main-sm::-webkit-scrollbar, .app-main-xs::-webkit-scrollbar {
  display: none;
}

.app-main-lg, .app-main-md, .app-main-sm, .app-main-xs {
  width: calc(100% - 230px);
  height: calc(100vh - 0px);
  scrollbar-width: none;
}

.app-main-md {
  width: calc(100% - 95px);
}

.app-main-sm {
  width: calc(100% - 95px);
}

.app-main-xs {
  width: calc(100% - 30px);
}

</style>



// WEBPACK FOOTER //
// src/views/homeView.vue